import {
  faArrowLeft,
  faArrowRight,
} from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans, useLingui } from '@lingui/react/macro';
import classNames from 'classnames';

type ImageNavigationControlsProps = {
  currentImageIndex: number;
  totalImages: number;
  onNavigate: (direction: 'prev' | 'next') => void;
};

export const ImageNavigationControls = ({
  currentImageIndex,
  totalImages,
  onNavigate,
}: ImageNavigationControlsProps) => {
  const { t } = useLingui();

  return (
    <div className="vai-flex vai-items-center vai-gap-4">
      <button
        className={classNames(
          'vai-h-8 vai-w-8 vai-flex vai-items-center vai-justify-center vai-rounded-md hover:vai-bg-zinc-700 vai-transition-colors vai-duration-200',
          {
            'vai-text-zinc-600 cursor-not-allowed': currentImageIndex <= 1,
            'vai-text-white': currentImageIndex > 1,
          },
        )}
        onClick={() => onNavigate('prev')}
        disabled={currentImageIndex <= 1}
        aria-label={t`Previous image`}
      >
        <FontAwesomeIcon size="sm" icon={faArrowLeft} />
      </button>

      <span className="vai-text-zinc-200 vai-font-medium vai-text-sm">
        {currentImageIndex} / {totalImages} <Trans>Images</Trans>
      </span>

      <button
        className={classNames(
          'vai-h-8 vai-w-8 vai-flex vai-items-center vai-justify-center vai-rounded-md hover:vai-bg-zinc-700 vai-transition-colors vai-duration-200',
          {
            'vai-text-zinc-600 cursor-not-allowed':
              currentImageIndex >= totalImages,
            'vai-text-white': currentImageIndex < totalImages,
          },
        )}
        onClick={() => onNavigate('next')}
        disabled={currentImageIndex >= totalImages}
        aria-label={t`Next image`}
      >
        <FontAwesomeIcon size="sm" icon={faArrowRight} />
      </button>
    </div>
  );
};
